import React, { useEffect, useState } from 'react';
import { StyleLeaderboardContainer, StyleLeaderboardTable, StyleLeaderboardTableThead, StyleLeaderboardTableTbody, StyleLeaderboardTableTr, StyleLeaderboardTableTh, StyleLeaderboardTableTd, StyleLeaderboardContent } from './Leaderboard.styled';
import TopBar from './TopBar';
// import TableCard from './TableCard';
import Button from '../Button/Button';
import TopPlayer from './TopPlayer';
import { getLeaderBoard } from '../../utils/getLeaderBoard';
import { LeaderboardData } from '../../types.ds';
import { Link } from 'react-router-dom';

interface Props {
    fullView: boolean
}

const Leaderboard = (props: Props) => {
    const [leaderboardData, setLeaderboardData] = useState<Array<LeaderboardData>>([]);
    const [filter, setFilter] = useState<string>("tokens_won");
    const [filterDate, setFilterDate] = useState<string>("24");

    useEffect(() => {
        const sortedData = [...leaderboardData].sort((a, b) => {
            if (filter === "tokens_won") {
                return b.tokens_won - a.tokens_won;
            }
            if (filter === "hands_won") {
                return b.hands_won - a.hands_won;
            }
            if (filter === "hands_played") {
                return b.hands_played - a.hands_played;
            }
            return 0;
        });
        setLeaderboardData(sortedData);
    }, [filter])

    useEffect(() => {
        const getLeaderboardData = async () => {
            const res = await getLeaderBoard(props.fullView, filterDate);
            const data = res?.leaderboardData;
            if (data == undefined) {
                return;
            }
            const dataArray = Object.values(data);
            setLeaderboardData(dataArray);
        }

        getLeaderboardData();
    }, [filterDate])

    const handleLoadMore = () => {

    }

    return (
        <StyleLeaderboardContainer>
            <TopBar fullView={props.fullView} setFilter={setFilter} setFilterDate={setFilterDate} />
            <StyleLeaderboardContent>
                <StyleLeaderboardTable>
                    <StyleLeaderboardTableThead>
                        <StyleLeaderboardTableTr>
                            <StyleLeaderboardTableTh>Rank</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Player</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Tokens Won</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Tokens Lost</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Hands Won</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Hands Played</StyleLeaderboardTableTh>
                            <StyleLeaderboardTableTh>Win Percentage</StyleLeaderboardTableTh>
                        </StyleLeaderboardTableTr>
                    </StyleLeaderboardTableThead>
                    <StyleLeaderboardTableTbody>
                        {
                            leaderboardData.map((data, index) => (
                                <StyleLeaderboardTableTr key={index}>
                                    <StyleLeaderboardTableTd>#{index + 1}</StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>
                                        <Link to={`https://solscan.io/account/${data.walletAddress}`} target='_blank' className="player-link">
                                            {data.name ? data.name :( data.walletAddress.slice(0, 4) + "..." + data.walletAddress.slice(-4))}
                                        </Link>
                                    </StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>{data.tokens_won / 1000} Sol</StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>{(data.tokens_lose ?? 0) / 1000} Sol</StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>{data.hands_won}</StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>{data.hands_played}</StyleLeaderboardTableTd>
                                    <StyleLeaderboardTableTd>{(data.hands_won / data.hands_played * 100).toFixed(1)}%</StyleLeaderboardTableTd>
                                </StyleLeaderboardTableTr>
                            ))
                        }
                    </StyleLeaderboardTableTbody>
                </StyleLeaderboardTable>
                {
                    props.fullView ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            {
                                leaderboardData.length > 0 && (
                                    <TopPlayer walletAddress={leaderboardData.length > 0 ? leaderboardData[0].walletAddress : null} place={"1st"} tokenWon={leaderboardData.length > 0 ? leaderboardData[0].tokens_won : null} />
                                )
                            }
                            {
                                leaderboardData.length > 1 && (
                                    <TopPlayer walletAddress={leaderboardData.length > 1 ? leaderboardData[1].walletAddress : null} place={"2nd"} tokenWon={leaderboardData.length > 1 ? leaderboardData[1].tokens_won : null} />
                                )
                            }
                            {
                                leaderboardData.length > 2 && (
                                    <TopPlayer walletAddress={leaderboardData.length > 2 ? leaderboardData[2].walletAddress : null} place={"3rd"} tokenWon={leaderboardData.length > 2 ? leaderboardData[2].tokens_won : null} />
                                )
                            }
                        </div>
                    )
                        :
                        (
                            <>
                                {
                                    leaderboardData.length > 0 && (
                                        <TopPlayer walletAddress={leaderboardData.length > 0 ? leaderboardData[0].walletAddress : null} place={"1st"} tokenWon={leaderboardData.length > 0 ? leaderboardData[0].tokens_won : null} />
                                    )
                                }
                            </>
                        )
                }

            </StyleLeaderboardContent>
        </StyleLeaderboardContainer>
    );
}

export default Leaderboard;
